// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"240":"bc6f24e1","334":"83e22e39","456":"fe632387","767":"fde4fe52","785":"736b0552"}[chunkId] + ".chunk.css";
};